import { ENTITY_NAME } from '@esentai/core/features/parkingWhitelist/consts';

export const RETRY_FETCH = `${ENTITY_NAME}/RETRY_FETCH`;
